// extracted by css-extract-rspack-plugin
export default {"cellWrapper":"UsersTable_cellWrapper__5oWpu","disabled":"UsersTable_disabled__C4Bs3","selectCell":"UsersTable_selectCell__mx3xu"};